<template>
  <transition name="fade" mode="out-in">
    <div v-if="visible" class="mega-modal" @click.self="hide">
      <div class="card h-100">
        <h5 class="card-header flex-shrink-0 d-flex align-items-center">
          <div :title="$t('status_' + printable.status)" class="d-flex flex-grow-1">
            <fa-layer class="fa-lg mr-1 align-middle">
              <fa :class="'text-' + this.status.color(printable.status)" icon="circle" />
              <fa :icon="statusIcon" transform="shrink-7" class="text-white" />
            </fa-layer>

            <h4 class="m-0">{{ printable.name }}</h4>
          </div>
          <button type="button" class="close" aria-label="Close" @click="hide">
            <span aria-hidden="true">&times;</span>
          </button>
        </h5>

        <div v-if="loading" class="loading">
          <fa-layer class="fa-lg fa-6x">
            <fa :icon="['fas','cloud']" />
            <fa :icon="['fal','arrow-down']" class="loading-icon" transform="shrink-9 right-2 down-1" style="color: white;" />
          </fa-layer>
        </div>

        <template v-else>
          <div class="card-body card-dashboard d-flex flex-column flex-grow-1">
            <div class="row flex-grow-1">
              <div class="col-sm-6 col-md-5 col-xl-4 d-flex flex-column details-wrapper">
                <card no-title no-margin-top>
                  <div>
                    <a v-if="printable.printable_pages[0]" :href="'/api/pdf/' + printable.id + '?preview=true'" target="_blank" class="d-flex mb-4 p-2 bg-gray rounded" style="position: relative">
                      <img :src="firstPage" class="img-fluid m-auto " style="max-height: 200px">
                      <div style="position: absolute; right: 1rem; bottom: 1rem;">
                        <fa :icon="['fal','search-plus']" class="fa-2x" />
                      </div>
                    </a>

                    <h6 class="m-0"><strong>Status: </strong> {{ $t('status_' + printable.status) }}</h6>
                    <div class="d-flex mt-3">
                      <div class="w-33">
                        <fa :icon="['fas','user-tie']" class="text-muted-light fa-lg mr-1" /> {{ printable.company.name }}
                      </div>
                      <div v-if="printable.project" class="w-66">
                        <fa :icon="['fas','project-diagram']" class="text-muted-light fa-lg mr-1" />
                        <router-link :to="{ 'path' : '/printables','query':{ 'project' : printable.project.id, 'company_id' : printable.project.company_id} }">{{ printable.project.name }}</router-link>
                      </div>
                    </div>
                  </div>
                  <ul class="modal-list mt-3">
                    <li>
                      <span class="list-title">Skapades</span>
                      <span :title="moment(printable.created_at).format('YYYY-MM-DD')" class="list-def">{{ !printable.created_at ? '' : moment(printable.created_at).format('YYYY-MM-DD') }}</span>
                    </li>
                    <li>
                      <span class="list-title">Deadline</span>
                      <span class="list-def">{{ !printable.deadline ? '' : moment(printable.deadline).format('YYYY-MM-DD') }}</span>
                    </li>
                    <li>
                      <span class="list-title">Export till tryck</span>
                      <span class="list-def">{{ !printable.exported_at ? '' : moment(printable.exported_at).format('YYYY-MM-DD') }}</span>
                    </li>
                    <li>
                      <span class="list-title">Levererans</span>
                      <span class="list-def">{{ !printable.delivered_at ? '' : moment(printable.delivered_at).format('YYYY-MM-DD') }}</span>
                    </li>
                    <li>
                      <span class="list-title">Trycksakstyp</span>
                      <span class="list-def"><span v-if="printable.printable_type">{{ printable.printable_type.name }}</span></span>
                    </li>
                    <li>
                      <span class="list-title">Granskare</span>
                      <span class="list-def"><span v-if="printable.auditor" class="badge badge-primary">{{ printable.auditor.name }}</span></span>
                    </li>
                    <li>
                      <span class="list-title">Kundgranskare</span>
                      <span class="list-def">
                        <span v-for="auditor in printable.client_auditors" :key="auditor.id">
                          <span v-if="auditor.user" class="badge badge-secondary mr-1">{{ auditor.user.name }}</span>
                        </span>
                      </span>
                    </li>
                    <li>
                      <span class="list-title">Slutnotis till</span>
                      <span class="list-def">
                        <span class="list-def"><span class="badge badge-info">{{ printable.final_notice ? printable.final_notice.name : '' }}</span></span>
                      </span>
                    </li>
                    <li>
                      <span class="list-title">Kundansvarig</span>
                      <span class="list-def"><span class="badge badge-success">{{ printable.client_manager ? printable.client_manager.name : '' }}</span></span>
                    </li>
                    <li>
                      <span class="list-title">Antal sidor</span>
                      <span class="list-def">{{ Object.keys(printable.printable_pages_grouped).length }}</span>
                    </li>
                    <li>
                      <span class="list-title">Tryckeri</span>
                      <span class="list-def">{{ printable.printer }}</span>
                    </li>
                    <li>
                      <span class="list-title">Komponenter</span>
                      <span class="list-def">
                        <span v-for="component in printable.components" :key="component.id" class="d-flex align-items-center mb-1 text-truncate">
                          <fa :icon="['fal','file-pdf']" class="mr-1" />
                          <router-link
                            :to="{
                              path : '/components/' + component.id,
                              query : {
                                'category_id' : component.category_id
                          }}">{{ component.attachment.filename }}</router-link>
                        </span>
                      </span>
                    </li>
                  </ul>

                  <div v-if="canEdit" slot="footer" class="d-flex justify-content-between">
                    <!--<router-link
                                                class="btn btn-primary btn-sm"
                                                :to="assembleQuery">Montera</router-link>-->
                    <button class="btn btn-primary btn-sm" @click="assembleQuery">Montera</button>
                    <router-link
                      :to="{ path : '/printables/' + printable.id + '/edit' }"
                      class="btn btn-secondary btn-sm">Redigera</router-link>
                  </div>
                </card>
              </div>
              <div class="col-sm-6 col-md-7 col-xl-8 timeline-wrapper">
                <card no-title class="h-100 card-timeline" max-height>
                  <header slot="header">
                    <h4>Tidslinje</h4>
                  </header>

                  <timeline :printable-id="printableId" :new-comment="newComment" :printable="printable" @loaded="setComments" />

                  <footer slot="footer">
                    <comment-form :pages="Object.keys(printable.printable_pages_grouped).length" :target-id="printableId" target="Printable" @updateComments="setComments" />
                  </footer>
                </card>
              </div>
            </div>

          </div>
          <div class="card-footer d-flex">
            <a v-if="canEdit" :href="'/api/pdf/' + printableId + '?output=download'" target="_blank" class="btn btn-secondary mr-auto">
              <fa :icon="['fal','external-link']" fixed-width />
              Exportera
            </a>

            <div v-if="!settingStatus" class="d-flex">
              <button
                v-if="canEdit && ['constructing','unconfirmed','done'].indexOf(printable.status) == -1"
                class="btn ml-2 btn-link text-danger"
                @click="confirmStatus('Vill du verkligen återställa statusen?','constructing')">
                <fa :icon="['fas','undo-alt']" class="mr-1" />Återställ
              </button>

              <button
                v-if="canEdit && printable.status == 'done'"
                class="btn ml-2 btn-link text-danger"
                @click="confirmStatus('Vill du verkligen ångra slutleverans?','delivered')">
                <fa :icon="['fas','undo-alt']" class="mr-1" />Ångra slutleverans
              </button>

              <button
                v-if="canEdit && printable.status == 'unconfirmed'"
                class="btn ml-2 btn-danger"
                @click="setStatus('constructing','unconfirmed')">
                <fa :icon="['fas','thumbs-up']" class="mr-1" />Bekräfta artikel
              </button>

              <button
                v-if="canEdit && printable.status == 'constructing'"
                class="btn ml-2 btn-info"
                @click="setStatus('proof_inhouse')">
                <fa :icon="status.icon('proof_inhouse')" />
                Skicka för internkorrektur
              </button>

              <button
                v-if="canEdit && printable.status == 'proof_inhouse'"
                class="btn ml-2 btn-info"
                @click="setStatus('proof_client')">
                <fa :icon="status.icon('proof_client')" />
                Skicka för kundkorrektur
              </button>

              <button
                v-if="printable.status == 'proof_client'"
                :disabled="hasApproved || !isAuditor"
                class="btn ml-2 btn-success"
                @click="setApproval('approved')">
                <fa :icon="status.icon('approved')" />
                <template v-if="hasApproved || !isAuditor">
                  Inväntar godkännande ({{ printable.approvals.approvals.length + 1 }} av {{ printable.approvals.auditors.length }})
                </template>
                <template v-else>
                  Godkänn för tryck ({{ printable.approvals.approvals.length + 1 }} av {{ printable.approvals.auditors.length }})
                </template>
              </button>

              <span v-if="printable.client_manager != null">
                <button
                  v-if="printable.status == 'proof_client' && printable.client_manager.email == this.currentUser"
                  class="btn ml-2 btn-success"
                  @click="forceApproval('approved')">
                  <fa :icon="status.icon('approved')" />
                  <template>
                    Tvinga godkännande för tryck
                  </template>
                </button>
              </span>

              <div v-if="canEdit && printable.status == 'approved'" class="input-group ml-2">
                <date-picker v-model="exportDate" :config="dpConfig" :class="{'is-invalid' : hasError == 'exportDate'}" placeholder="Välj exportdatum" class="mr-0" />
                <div class="input-group-append">
                  <button
                    class="btn btn-success"
                    @click="setStatus('delivered')">
                    <fa :icon="status.icon('delivered')" />
                    Exportera
                  </button>
                </div>
              </div>

              <div v-if="canEdit && printable.status == 'delivered'" class="input-group ml-2">
                <date-picker v-model="deliveryDate" :config="dpConfig" :class="{'is-invalid' : hasError == 'deliveryDate'}" placeholder="Välj leveransdatum" class="mr-0" />
                <div class="input-group-append">
                  <button
                    class="btn btn-success"
                    @click="setStatus('done')">
                    <fa :icon="status.icon('done')" />
                    Märk som slutlevererad
                  </button>
                </div>
              </div>
            </div>
            <div v-else>
              <button
                class="btn ml-2 btn-secondary">
                <fa :icon="['fal','circle-notch']" spin />
                Uppdaterar status...
              </button>
            </div>
          </div>
        </template>
      </div>

      <assemble-modal :printable="assemble_printable" open="false" @clear="resetAssemble" @update-printable="refreshPrintable" />
    </div>
  </transition>
</template>

<script>
import axios from 'axios'
import store from '~/store'
import $ from 'jquery'
import swal from 'sweetalert2'

import CommentForm from '~/components/CommentForm'
import AssembleModal from '~/components/AssembleModal'
import Timeline from '~/components/Timeline'

export default {
  name: 'PrintableModal',
  middleware: ['auth'],
  components: {
    CommentForm, Timeline, AssembleModal
  },
  props: [
    'printableId',
    'open'
  ],
  data () {
    return {
      loading: true,
      visible: false,
      newComment: null,
      assemble_id: null,
      assemble_printable: null,
      settingStatus: false,
      firstPage: '',
      exportDate: null,
      deliveryDate: null,
      hasError: null,
      version: null,
      printable: {
        name: '',
        company: {
          name: ''
        },
        auditor: {
          name: ''
        },
        client_auditor: {
          name: ''
        },
        client_manager: {
          name: ''
        },
        final_notice: {
          name: ''
        },
        printable_type: {
          name: ''
        },
        project: {
          name: ''
        }
      },
      buttons: [
      ],
      attachment: null,
      dpConfig: {
        format: 'YYYY-MM-DD',
        useCurrent: false,
        locale: 'sv'
      }
    }
  },
  computed: {
    canEdit () {
      return store.getters['auth/user'].role >= 3
    },
    currentUser () {
      return store.getters['auth/user'].email
    },
    statusIcon () {
      return this.status.icon(this.printable.status)
    },
    hasApproved () {
      return this.printable.approvals.approvals.indexOf(this.currentUser) > -1
    },
    isAuditor () {
      return this.printable.client_auditors.find(auditor => auditor.user.email == this.currentUser)
    }
  },
  watch: {
    printableId (n, o) {
      if (this.printableId && !this.visible) this.show()
      else if (!this.printableId && this.visible) this.hide()

      if (this.printableId) {
        this.fetchPrintable(this.printableId)
      }
    },
    '$route': 'routeChanged'
  },
  created () {
    if (this.printableId) {
      this.fetchPrintable(this.printableId)
      this.show()
      this.setVersion()
      // this.exportDate = this.moment().format('YYYY-MM-DD');
    }
  },
  destroyed () {
    this.toggleBodyClass('remove', 'fixed')
  },
  methods: {
    setVersion () {
      this.version = new Date().getTime()
    },
    routeChanged (n, o) {
      if (n.name == 'printables.id.assemble') {
        this.openAssembly()
      } else {
        this.assemble_id = null
        this.assemble_printable = null
      }
    },
    hide () {
      this.visible = false
      this.$emit('clear')
      this.toggleBodyClass('remove', 'fixed')
      this.unBindKeys()
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    show () {
      this.visible = true
      this.toggleBodyClass('add', 'fixed')
      this.bindKeys()

      if (this.$route.name == 'printables.id.assemble') {
        this.openAssembly()
      }
    },
    setPrintable (data) {
      this.printable = data
      this.loading = false

      if (data.printable_pages && data.printable_pages[0]) {
        let page = data.printable_pages[0].attachment_page

        if (page && page.prefix) {
          this.firstPage = page.prefix + page.path + '?v=' + this.version
        }
      }

      if (this.$route.params.name == 'printables.id.assemble') {
        this.openAssembly()
      }
    },
    onKeyUp (event) {
      if (event.keyCode == 27) { // Escape
        this.hide()
      }
    },
    assembleQuery () {
      this.$router.push({
        name: 'printables.id.assemble',
        query: Object.assign({}, this.$route.query),
        params: {
          id: this.printableId
        }
      })
    },
    openAssembly () {
      this.assemble_printable = this.printable
    },
    resetAssemble () {
      this.assemble_printable = null

      this.$router.push({
        name: 'printables.id',
        query: Object.assign({}, this.$route.query),
        params: {
          id: this.printableId
        }
      })
    },
    bindKeys () {
      window.addEventListener('keyup', this.onKeyUp)
    },
    unBindKeys () {
      window.removeEventListener('keyup', this.onKeyUp)
    },
    toggleBodyClass (addRemoveClass, className) {
      const el = document.body

      if (addRemoveClass === 'add') {
        el.classList.add(className)
      } else {
        el.classList.remove(className)
      }
    },
    ellipsis (str) {
      if (str.length > 35) {
        return str.substr(0, 20) + '...' + str.substr(str.length - 10, str.length)
      }
      return str
    },
    color () {
      let colors = ['primary', 'secondary', 'warning', 'success', 'info', 'danger']
      return 'is-' + colors[Math.floor(Math.random() * 7)]
    },
    setComments (comment) {
      if (comment) {
        this.newComment = comment.id
      }
    },
    confirmStatus (text, status) {
      let self = this

      swal({
        title: text,
        text: this.$t('cant_undo'),
        type: 'error',
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonText: this.$t('reset'),
        confirmButtonClass: 'bg-danger',
        cancelButtonText: this.$t('cancel')
      }).then(result => {
        if (result.value) {
          self.setStatus(status)
        }
      })
    },
    refreshPrintable () {
      this.fetchPrintable(this.printableId)
    },
    async setStatus (status) {
      this.hasError = null
      this.settingStatus = true
      let params = {
        status: status,
        status_was: this.printable.status
      }

      if (this.printable.status == 'approved' && status != 'constructing') {
        if (this.printable.final_notice) {
          const result = await swal({
            title: 'Slutnotis',
            input: 'textarea',
            inputAttributes: {
              autocapitalize: 'off'
            },
            confirmButtonText: 'Skicka',
            cancelButtonText: 'Avbryt',
            showCancelButton: true,
            allowOutsideClick: () => !swal.isLoading()
          })

          if (result) {
            if (result.dismiss) {
              this.settingStatus = false
              return
            }

            if (result.value && result.value != '') {
              params.final_notice = result.value
            }

            if (this.exportDate) {
              params.date_exported = this.exportDate
            } else {
              this.hasError = 'exportDate'
              this.settingStatus = false
              return
            }
          } else {
            return
          }
        } else {
          if (this.exportDate) {
            params.date_exported = this.exportDate
          } else {
            this.hasError = 'exportDate'
            this.settingStatus = false
            return
          }
        }
      }

      if (this.printable.status == 'delivered' && status != 'constructing') {
        if (this.deliveryDate) {
          params.date_delivered = this.deliveryDate
        } else {
          this.hasError = 'deliveryDate'
          this.settingStatus = false
          return
        }
      }

      const { data } = await axios.post('/api/printable/' + this.printableId + '/status', params)

      this.printable.status = status
      this.setComments(data)

      this.settingStatus = false
      this.refreshPrintable(this.printable.id)
      this.$store.dispatch('sidebar/fetchSidebar', this.$route.query.company_id)
    },
    async setApproval (status) {
      this.settingStatus = true
      let params = {
        status: status
      }

      const { data } = await axios.post('/api/printable/' + this.printableId + '/approve', params)
      this.refreshPrintable()

      this.settingStatus = false
    },
    async forceApproval (status) {
      this.settingStatus = true
      let params = {
        status: status
      }

      const { data } = await axios.post('/api/printable/' + this.printableId + '/force-approve', params)
      this.setComments(data)
      this.settingStatus = false
      this.refreshPrintable(this.printable.id)
    },

    async fetchPrintable (id) {
      const { data } = await axios.get('/api/printable/' + id)

      this.setPrintable(data)
    }
  }
}
</script>
<style lang="scss">
    .timeline-wrapper, .details-wrapper {
        max-height: 100%;
        overflow-x: auto;
        overflow-y: hidden;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/PrintableModal.vue